import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface OperatorInfo {
  id: string
  email: string
  name: string
  role: string
  is_active: boolean
  created_at: string
  permissions: string[]
}

interface OperatorSessionState {
  operator: OperatorInfo | null
  token: string | null
  setSession: (operator: OperatorInfo, token: string) => void
  clearSession: () => void
}

export const useOperatorSession = create<OperatorSessionState>()(
  persist(
    (set) => ({
      operator: null,
      token: null,
      setSession: (operator, token) => set({ operator, token }),
      clearSession: () => set({ operator: null, token: null }),
    }),
    {
      name: 'admin.session',
    },
  ),
)
